import { getFormattedDecimalValue } from "@components/Amount";
import {
  REJECTED,
  ERROR,
  FAILED,
  CANCELLED,
} from "@api/services/transactions/shapes/TransactionStatusEnum";
import {
  FUNDING,
  CAPITAL_RETURN,
  INVESTMENT_RETURN,
  SALE_PROFIT,
  SPONSOR_PROMOTE,
} from "@api/services/transactions/shapes/TransactionTypeEnum";

export type TotalTransaction = {
  type: string;
  amount: number;
  status: string;
};

const SKIP_STATUSES = [
  REJECTED,
  ERROR,
  FAILED,
  CANCELLED,
];

const FUNDING_TYPES = [ FUNDING ];

const DISTRIBUTION_TYPES = [
  CAPITAL_RETURN,
  INVESTMENT_RETURN,
  SALE_PROFIT,
  SPONSOR_PROMOTE,
];

const computeTransactionsTotal = (types: string[], transactions: TotalTransaction[]): number => {
  const total = transactions
    .filter(({ status }) => !SKIP_STATUSES.includes(status))
    .filter(({ type }) => types.includes(type))
    .map(({ amount }) => amount)
    .reduce((sum, amount) => getFormattedDecimalValue(sum, amount, "plus"), 0);

  return total;
};

const computeFundingTransactionsTotal = (transactions: TotalTransaction[]): number => {
  const total = computeTransactionsTotal(FUNDING_TYPES, transactions);

  return total;
};

const computeDistributionsTransactionsTotal = (transactions: TotalTransaction[]): number => {
  const total = computeTransactionsTotal(DISTRIBUTION_TYPES, transactions);

  return total;
};

export {
  computeFundingTransactionsTotal,
  computeDistributionsTransactionsTotal,
};
